import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-215bbeb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "section-title" }
const _hoisted_4 = { class: "list-box" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "pagination-box" }

import { ref, onMounted } from 'vue';
  import { Collection } from '@/stores';
  import { request, isMobile } from '@/utils';
  import Filter from './components/filter.vue';
  import FilterTag from './components/filter-tag.vue';
  import { useI18n } from 'vue-i18n';
  import { useRoute } from 'vue-router';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const route = useRoute();
  const categoryId = ref(Number(route.query.category) || 0);
  const categoryCollection = Collection.create<Collection>({
    params: {
      per_page: 99
    },
    fetch: (params: object) => request.get('article_categories', { params })
  });
  const tagCollection = Collection.create<Collection>({
    params: {
      per_page: 99,
      story_tags: true,
      article_category_id: categoryId.value || undefined,
    },
    fetch: (params: object) => request.get('acts_as_taggable_on/tags', { params })
  });

  const storyCollection = Collection.create<Collection>({
    params: {
      type_eq: 'Story',
      article_category_id_eq: ''
    },
    fetch: (params: object) => request.get('articles', { params })
  });

  const mobile = isMobile();

  onMounted(async () => {
    await Promise.all([
      categoryCollection.fetchData(),
      storyCollection.fetchData()
    ]);
    if (categoryId.value && !mobile) {
      await tagCollection.fetchData();
    }
  });

  async function handleCatrgoryChange(id: number) {
    storyCollection.params.article_category_id_eq = id || undefined;
    categoryId.value = id;
    storyCollection.params.tags_name_eq = undefined;
    storyCollection.fetchData();
    if (!mobile && id) {
      tagCollection.params.article_category_id = id || undefined;
      tagCollection.fetchData();
    } else {
      tagCollection.resetData();
    }
    history.pushState(null, '', `?category=${id}`);
  }

  function handleTagChange(tagName: string) {
    storyCollection.params.tags_name_eq = tagName === t('All') ? undefined : tagName;
    storyCollection.fetchData();
  }

  function handlePageChange(page: any) {
    storyCollection.params.page = page;
    storyCollection.fetchData();
  }

return (_ctx: any,_cache: any) => {
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_AppCardStory = _resolveComponent("AppCardStory")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)('Story')), 1),
      (_unref(categoryCollection).data.length)
        ? (_openBlock(), _createBlock(Filter, {
            key: 0,
            class: "filter",
            "category-id": categoryId.value,
            list: _unref(categoryCollection).data,
            onChange: handleCatrgoryChange
          }, null, 8, ["category-id", "list"]))
        : _createCommentVNode("", true),
      (_unref(tagCollection).data.length)
        ? (_openBlock(), _createBlock(FilterTag, {
            key: 1,
            class: "filter-tag",
            list: _unref(tagCollection).data,
            onChange: handleTagChange
          }, null, 8, ["list"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (!_unref(storyCollection).data.length)
          ? (_openBlock(), _createBlock(_component_AppEmptyView, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(storyCollection).data, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "col-6 col-md-4 item-box"
                  }, [
                    _createVNode(_component_AppCardStory, { data: item }, null, 8, ["data"])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_AppPagination, {
                  total: _unref(storyCollection).meta.total,
                  "per-page": _unref(storyCollection).meta.per_page,
                  page: _unref(storyCollection).meta.page,
                  onChange: handlePageChange
                }, null, 8, ["total", "per-page", "page"])
              ])
            ], 64))
      ])
    ])
  ]))
}
}

})